/**
 * Labstep
 *
 * @module core/Form/ShowEdit/Text/Multiple
 * @desc A component that displays any number of ShowEditText components.
 * Just like the ShowEditText component, any field will toggle onBlur and perform
 * an optimistic update. If any of the fields are left empty, no api
 * requests are sent thereby leaving the last saved value to be restored.
 */

import { FormShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import styles from './styles.module.scss';
import type { IFormShowEditTextMultipleProps } from './types';

export const FormShowEditTextMultiple: React.FC<
  IFormShowEditTextMultipleProps
> = ({
  entity,
  entityName,
  fields,
  customChildren,
  id,
  createProps,
}) => {
  return (
    <div className={styles.container}>
      {fields.map((field, idx) => {
        return (
          <FormShowEditText
            id={id}
            // FIXME react/no-array-index-key
            key={idx}
            entity={entity}
            entityName={entityName}
            field={field}
            createProps={createProps}
          >
            {customChildren ? (
              customChildren(entity[field.name])
            ) : (
              <div>{entity[field.name]}</div>
            )}
          </FormShowEditText>
        );
      })}
    </div>
  );
};
